'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

require('../../styles/sections/index-collections.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('index-collections', {
  onLoad: function onLoad() {
    var container = this.container;
    var collections = container.querySelectorAll('[data-featured-collection]');
    window.collectionRanges = [];
    window.collectionRangeDropdowns = [];

    collections.forEach(function (element, index) {
      collectionRanges[index] = new Limelight('' + element.dataset.target, {
        showCallback: function showCallback(element, elements) {
          collectionRanges.forEach(function (range, i) {
            if (index !== i) {
              range.hide();
            }
          });

          var collection = (0, _jquery2.default)(element.target).find('.collection-products-slider');
          var limit = (0, _jquery2.default)(element.target).data('collection-products');

          var settings = (0, _slick2.default)({
            appendArrows: (0, _jquery2.default)(collection).closest('.slick-slider-wrapper').find('.slick-arrows'),
            arrows: true,
            infinite: false,
            slidesToShow: limit,
            slidesToScroll: limit,
            responsive: [{
              breakpoint: Breakpoints['medium'],
              settings: {
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }, {
              breakpoint: Breakpoints['small'],
              settings: {
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }]
          });

          collection.slick(settings);

          collectionRangeDropdowns.forEach(function (dropdown, i) {
            dropdown.hide();
          });
        },
        hideCallback: function hideCallback(element, elements) {
          var collection = (0, _jquery2.default)(element.target).find('.collection-products-slider');
          collection.slick('unslick');
        }
      });

      collectionRangeDropdowns[index] = new Limelight(element.dataset.target + '_dropdown');
    });

    if (collectionRanges[0]) {
      collectionRanges[0].show();
    }

    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);
  },
  onUnload: function onUnload() {}
});